import { render, staticRenderFns } from "./Visualizar-Produto.vue?vue&type=template&id=454f3472&scoped=true&"
import script from "./Visualizar-Produto.vue?vue&type=script&lang=js&"
export * from "./Visualizar-Produto.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar-Produto.vue?vue&type=style&index=0&id=454f3472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f3472",
  null
  
)

export default component.exports